import { api } from './client';

export interface TgWebAppAuthRequest {
  initData: string;
  accept_terms: boolean;
  accept_personal_data: boolean;
  accept_ai_data: boolean;
}
export interface TgWebAppAuthResponse {
  user_id: number;
  login: string;
  access_token: string;
  expires_in: number;
  tg_user_id: number;
  is_new_user: boolean;
}

export interface LinkStartResponse {
  code: string;
  expires_in_sec: number;
  instructions: string;
  bot_url: string;
}

export interface LinkStatusResponse {
  linked: boolean;
  tg_user_id: number | null;
  tg_username: string | null;
  linked_at: string | null;
  nudges_enabled: boolean;
}

export interface NudgesToggleResponse {
  nudges_enabled: boolean;
}

function isLinkStatusResponse(value: unknown): value is LinkStatusResponse {
  return typeof value === 'object'
    && value !== null
    && typeof (value as LinkStatusResponse).linked === 'boolean';
}

export const telegramApi = {
  webappAuth: (req: TgWebAppAuthRequest) =>
    api.post<TgWebAppAuthResponse>('/api/v1/telegram/webapp-auth', req).then(r => r.data),
  linkStart: () =>
    api.post<LinkStartResponse>('/api/v1/telegram/link/start').then(r => r.data),
  linkStatus: () =>
    api.get<unknown>('/api/v1/telegram/link/status').then((response) => {
      if (!isLinkStatusResponse(response.data)) {
        throw new Error('Telegram integration is unavailable');
      }
      return response.data;
    }),
  unlink: () =>
    api.post('/api/v1/telegram/link/unlink').then(r => r.data),
  setNudges: (enabled: boolean) =>
    api.post<NudgesToggleResponse>('/api/v1/telegram/nudges/toggle', { enabled }).then(r => r.data),
};
